import { getLocation } from '../constants/locations.constant';

export class Location {
  index!: number;
  name!: string;
  displayName!: string;
  color!: string;
  isRoyal!: boolean;
  isMarket!: boolean;
  isIslandLocation!: boolean;
  isSmugglersNetwork!: boolean;

  constructor() {}

  static fromJson(json: string): Location {
    const plainObject = JSON.parse(json);

    let result = getLocation(Number(plainObject.index));

    return result;
  }
}

export function createLocation(
  _index: number,
  _name: string,
  _displayName: string,
  _color: string,
  _isRoyal: boolean,
  _isMarket: boolean,
  _isIslandLocation: boolean,
  _isSmugglersNetwork: boolean
): Location {
  return {
    index: _index,
    name: _name,
    displayName: _displayName,
    color: _color,
    isRoyal: _isRoyal,
    isMarket: _isMarket,
    isIslandLocation: _isIslandLocation,
    isSmugglersNetwork: _isSmugglersNetwork,
  };
}
